import { createRequest, setStorage } from '@mkmp/core'
import { Config } from './config'

const supApi = createRequest('sup')
const prcApi = createRequest('prc')
const coreApi = createRequest('core')

/**
 * 验证用户信息
 * @param code
 * @returns
 */
export const validateUser = async (code: string): Promise<any> => supApi(Config.validateUser, { data: { code } })

/**
 * 获取主体
 * @returns
 */
export const getVendors = () => supApi(Config.getVendors)

/**
 * 获取用户信息
 * @returns
 */
export const getUserInfo = () => supApi(Config.getUserInfo)

/**
 * 更新用户信息
 * @param data
 * @returns
 */
export const updateUser = (data: any) => supApi(Config.updateUser, { data })

/**
 * 获取供应商信息
 * @param id
 * @returns
 */
export const getSupplier = (id: string): Promise<any> => {
  return supApi(Config.getSupplier, { params: { id } })
}

/**
 * 绑定供应商信息
 * @param data
 * @returns
 */
export const bindSupplier = (data: any): Promise<any> => {
  return supApi(Config.bindSupplier, { data })
}

/**
 * 获取订单列表
 * @param params
 * @returns
 */
export const getOrders = (params: any): Promise<any> => {
  return supApi(Config.getOrders, { params })
}

/**
 * 获取订单详情
 * @param id
 * @returns
 */
export const getOrder = (id: string): Promise<any> => {
  return supApi(Config.getOrder, { params: { id } })
}

/**
 * 确认订单
 * @param data
 * @returns
 */
export const confirmOrder = (orderId: string): Promise<any> => supApi(Config.confirmOrder, { data: { orderId } })

/**
 * 退回订单
 * @param data
 * @returns
 */
export const returnOrder = (id: any): Promise<any> => supApi(Config.returnOrder, { params: { id } })

/**
 * 发起验收
 * @param data
 * @returns
 */
export const submitAccept = (data: any): Promise<any> => supApi(Config.submitAccept, { data })

/**
 * 更新验收信息
 * @param data
 * @returns
 */
export const updateAccept = (data: any): Promise<any> => supApi(Config.updateAccept, { data })

/**
 * 确认验收单
 * @param data
 * @returns
 */
export const confirmAccept = (data: any): Promise<any> => {
  return supApi(Config.confirmAccept, { data })
}

/**
 * 获取验收详情
 * @param id
 * @returns
 */
export const getAccept = (id: string): Promise<any> => {
  return supApi(Config.getAccept, { params: { id } })
}

/**
 * 获取供应商验收单
 * @param data
 * @returns
 */
export const getAcceptList = (data: any): Promise<any> => {
  return supApi(Config.getAcceptList, { data })
}

/**
 * 获取微信授权后用户存储信息
 */
export const getWechatUser = async (code: string): Promise<boolean> => {
  const { userId = '' } = await coreApi(Config.getWechatUser, { data: { code } })
  setStorage('app-user-id', userId)
  return true
}

/**
 * 撤回验收单
 * @param id
 * @returns
 */
export const deleteAccept = (id: string) => {
  return prcApi(Config.deleteAccept, { params: { id } })
}
